<div class="sponsersect">
<div class="sectpad container-fluid text-center">
<span><img src="assets/images/sponser1.png" class="img-responsive"></span>
<span><img src="assets/images/sponser2.png" class="img-responsive"></span>
<span><img src="assets/images/sponser3.png" class="img-responsive"></span>
<span><img src="assets/images/sponser4.png" class="img-responsive"></span>
<span><img src="assets/images/sponser5.png" class="img-responsive"></span>
<span><img src="assets/images/sponser6.png" class="img-responsive"></span>
<span><img src="assets/images/sponser7.png" class="img-responsive"></span>
</div>
 </div>